export { default, defaultColumnProps } from './ExploreBlogTypesMobileSection'